export default __webpack_public_path__ + "static/media/arrow-down.91b023ed.svg";